/* Copyright (c) 2022 Xperi. All Rights Reserved.  */

import { BrandingUIBundleServiceRepositoryImpl } from '../impls/BrandingUIBundleServiceRepositoryImpl';
import { IBrandingUIBundleServiceRepository } from '../interfaces/IBrandingUIBundleServiceRepository';
import { TServicesParams } from '../types/TServicesParams';

export class BrandingUIBundleService implements IBrandingUIBundleServiceRepository {
    private oBrandingUIBundleServiceRepository: BrandingUIBundleServiceRepositoryImpl;

    constructor(params: TServicesParams) {
        this.oBrandingUIBundleServiceRepository = new BrandingUIBundleServiceRepositoryImpl(params);
    }

    async getBrandingUiBundleInfo(): Promise<void> {
        return this.oBrandingUIBundleServiceRepository.getBrandingUiBundleInfo();
    }

    getBrandingUiInfoForKey(key: string): any {
        return this.oBrandingUIBundleServiceRepository.getBrandingUiInfoForKey(key);
    }
}
